// @flow
import React from 'react';

import { withHelmet } from 'infrastructure/seo/Helmet';
import Breadcrumb from 'components/fragments/Breadcrumb';

export type StateProps = {
  title: string,
  slug_parent: string,
  titleParent: string,
  featured_media: {
    src: string,
    legend: string
  },
  meta_description: string,
  meta_title: string,
  banniere: string,
  filarianne: { name: string, to: string }[],
};

type Props = {
  title: string,
  withSubMenu: boolean,
  className?: string,
  parentSlug?: string, 
  parentName?: string
} & StateProps;

const PagePartenaireHeader = (props: Props) => {
  const { 
    title,
    filarianne
  } = props;

  return (
    <div className="col col-lg-8on9 mb-3">
      <Breadcrumb breadcrumbStyle="mt-4" elements={[...filarianne, title]} />
      <h1 className="article_title mt-6">{title}</h1>
    </div>
  );
};

export default withHelmet(PagePartenaireHeader)((Helmet, pageProps) => {
  const ogimage = pageProps.featured_media.src;
  const ogimagetitle = pageProps.featured_media.title;
  return (
    <Helmet>
      <title>{pageProps.meta_title}</title>
      <meta name={'description'} content={`${pageProps.meta_description.slice(0, 197)}...`} />
      <meta property={'og:url'} content={window.location.href} />
      <meta property={'og:title'} content={pageProps.meta_title} />
      <meta property={'og:description'} content={`${pageProps.meta_description.slice(0, 197)}...`} />
      {ogimage && <meta property={'og:image'} content={ogimage} />}
      {ogimage && <meta property={'og:image:url'} content={ogimage} />}
      {ogimage && ogimagetitle && <meta property={'og:image:title'} content={ogimagetitle} />}
    </Helmet>
  );
});
